import { BLUR_URL, imageOpt } from '@/utils/images';
import { Box, Flex, Grid, Group, createStyles } from '@mantine/core';
import {
  ITechstack,
  ITechstackDetailRelativeTechstack,
} from '@/types/techstack';

import DMText from '@/components/DMText';
import { FRAMEWORK_LOGO_ENDPOINT } from '@/config/endpoint';
import Image from 'next/image';
import { mixpanelTrack } from '@/utils/mixpanel';
import themeVariables from '@/styles/themeVariables';
import { useRouter } from 'next/navigation';

const useTechstackDetailRelativeTechstacksStyle = createStyles((theme) => ({
  techstackCardWrapper: {
    gap: 24,
    flexWrap: 'nowrap',
    cursor: 'pointer',
    ':hover': {
      div: {
        fontWeight: 500,
      },
    },
    [theme.fn.smallerThan('sm')]: {
      gap: 12,
    },
  },

  techstackImageWrapper: {
    overflow: 'hidden',
    borderRadius: 10,
    border: '1px solid rgba(0, 0, 0, 0.08)',
  },

  techstackImage: {
    width: 48,
    height: 48,
    [theme.fn.smallerThan('sm')]: {
      width: 40,
      height: 40,
    },
  },

  techstackText: {
    fontSize: 16,
    fontWeight: 400,
    transition: '150ms all ease',
    [theme.fn.smallerThan('sm')]: {
      fontSize: 15,
      lineHeight: '20px',
    },
  },
}));

const TechstackDetailRelativeTechstacks = ({ data }: { data: ITechstack }) => {
  const { push } = useRouter();
  const { classes } = useTechstackDetailRelativeTechstacksStyle();

  const RelativeTechstackCard = ({
    techstack,
  }: {
    techstack: ITechstackDetailRelativeTechstack;
  }) => (
    <Group id={`${techstack.id}`} className={classes.techstackCardWrapper}>
      <Box className={classes.techstackImageWrapper}>
        <Image
          width={48}
          height={48}
          src={imageOpt(`${FRAMEWORK_LOGO_ENDPOINT}/${techstack.id}.png`, 720)}
          placeholder={'blur'}
          blurDataURL={BLUR_URL}
          className={classes.techstackImage}
          alt="techstack-logo"
          priority
        />
      </Box>
      <DMText
        className={classes.techstackText}
        dColor={themeVariables.darkMode.normal}
      >
        {techstack.name}
      </DMText>
    </Group>
  );

  return data?.relative_techstacks && data?.relative_techstacks?.length > 0 ? (
    <>
      <Flex justify={'space-between'} mt={80}>
        <DMText
          size={22}
          weight={600}
          lts={-0.4}
          dColor={themeVariables.darkMode.normal}
        >
          연관 기술 스택
        </DMText>
      </Flex>
      <Grid columns={24} gutter={20} mt={22}>
        {data?.relative_techstacks?.map((techstack) => (
          <Grid.Col
            key={techstack.id}
            xl={4}
            lg={6}
            md={6}
            sm={8}
            xs={12}
            onClick={() => {
              mixpanelTrack(
                'TechstackDetailPage_RelativeTechstack',
                'Clicked',
                { id: techstack.id }
              );
              push(`/techstack/detail/${techstack.id}`);
            }}
          >
            <RelativeTechstackCard techstack={techstack} />
          </Grid.Col>
        ))}
      </Grid>
    </>
  ) : null;
};

export default TechstackDetailRelativeTechstacks;
